import { createClient } from '@/lib/supabase/client';

export interface SocialLink {
  platform: string;
  label: string;
  url: string;
  sortOrder: number;
}

let cachedLinks: SocialLink[] | null = null;
let pendingLinks: Promise<SocialLink[]> | null = null;

export const socialLinksService = {
  async getLinks(): Promise<SocialLink[]> {
    if (cachedLinks) return cachedLinks;
    if (pendingLinks) return pendingLinks;
    pendingLinks = fetchLinks()
      .then((rows) => {
        cachedLinks = rows;
        return rows;
      })
      .finally(() => {
        pendingLinks = null;
      });
    return pendingLinks;
  },
};

async function fetchLinks(): Promise<SocialLink[]> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('site_social_links')
    .select('platform, label, url, sort_order')
    .eq('active', true)
    .not('url', 'is', null)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? [])
    .filter((r: any) => typeof r.url === 'string' && r.url.trim() !== '')
    .map((r: any) => ({
      platform: String(r.platform ?? ''),
      label: String(r.label ?? ''),
      url: String(r.url).trim(),
      sortOrder: Number(r.sort_order ?? 0),
    }));
}

export function getCachedSocialLinks(): SocialLink[] | null {
  return cachedLinks;
}
